import { defineMessages } from 'react-intl';

export default defineMessages({
    pageHeader: {
        id: 'ml.quoteandbind.pup.ml-pup-vehicle-driver-household-details.page-header',
        defaultMessage: 'The vehicle and drivers below will be covered under your umbrella policy. Please make sure everything you want covered is listed ant the information is accurate.'
    },
    weWillReviewYourQuoteNext: {
        id: 'ml.quoteandbind.pup.ml-pup-vehicle-driver-household-details.We\'ll review additional exposure details next',
        defaultMessage: 'We\'ll gather {reviewAdditionalExposure} next'
    },
    reviewAdditionalExposure: {
        id: 'ml.quoteandbind.pup.ml-pup-vehicle-driver-household-details.additional exposure details',
        defaultMessage: 'additional exposure details'
    },
    noInformationExists: {
        id: 'ml.quoteandbind.pup.ml-pup-vehicle-driver-household-details.No Information Exists',
        defaultMessage: 'No Information Exists'
    },
    vehicleListTitle: {
        id: 'ml.quoteandbind.pup.ml-pup-vehicle-driver-household-details.vehicle-list.Vehicles',
        defaultMessage: 'Vehicles'
    },
    type: {
        id: 'ml.quoteandbind.pup.ml-pup-vehicle-driver-household-details.vehicle-list.Type',
        defaultMessage: 'Type'
    },
    Year: {
        id: 'ml.quoteandbind.pup.ml-pup-vehicle-driver-household-details.vehicle-list.Year',
        defaultMessage: 'Year'
    },
    Make: {
        id: 'ml.quoteandbind.pup.ml-pup-vehicle-driver-household-details.vehicle-list.Make',
        defaultMessage: 'Make'
    },
    Model: {
        id: 'ml.quoteandbind.pup.ml-pup-vehicle-driver-household-details.vehicle-list.Model',
        defaultMessage: 'Model'
    },
    BodyType: {
        id: 'ml.quoteandbind.pup.ml-pup-vehicle-driver-household-details.vehicle-list.Body Type',
        defaultMessage: 'Body Type'
    },
    Trim: {
        id: 'ml.quoteandbind.pup.ml-pup-vehicle-driver-household-details.vehicle-list.Trim',
        defaultMessage: 'Trim'
    },
    VIN: {
        id: 'ml.quoteandbind.pup.ml-pup-vehicle-driver-household-details.vehicle-list.VIN',
        defaultMessage: 'VIN'
    },
    Excluded: {
        id: 'ml.quoteandbind.pup.ml-pup-vehicle-driver-household-details.vehicle-list.Excluded',
        defaultMessage: 'Excluded'
    },
    Actions: {
        id: 'ml.quoteandbind.pup.ml-pup-vehicle-driver-household-details.ACTIONS',
        defaultMessage: 'ACTIONS'
    },
    AddVehicle: {
        id: 'ml.quoteandbind.pup.ml-pup-vehicle-driver-household-details.vehicle-list.ADD VEHICLE',
        defaultMessage: 'ADD VEHICLE'
    },
    Driver: {
        id: 'ml.quoteandbind.pup.ml-pup-vehicle-driver-household-details.driver-list.Driver',
        defaultMessage: 'Driver'
    },
    Drivers: {
        id: 'ml.quoteandbind.pup.ml-pup-vehicle-driver-household-details.driver-list.Drivers',
        defaultMessage: 'Drivers'
    },
    NAME: {
        id: 'ml.quoteandbind.pup.ml-pup-vehicle-driver-household-details.driver-list.NAME',
        defaultMessage: 'NAME'
    },
    DATEOFBIRTH: {
        id: 'ml.quoteandbind.pup.ml-pup-vehicle-driver-household-details.driver-list.DATE OF BIRTH',
        defaultMessage: 'DATE OF BIRTH'
    },
    GENDER: {
        id: 'ml.quoteandbind.pup.ml-pup-vehicle-driver-household-details.driver-list.GENDER',
        defaultMessage: 'GENDER'
    },
    MARITALSTATUS: {
        id: 'ml.quoteandbind.pup.ml-pup-vehicle-driver-household-details.driver-list.MARITAL STATUS',
        defaultMessage: 'MARITAL STATUS'
    },
    ADDDRIVER: {
        id: 'ml.quoteandbind.pup.ml-pup-vehicle-driver-household-details.driver-list.ADD DRIVER',
        defaultMessage: 'ADD DRIVER'
    },
    Edit: {
        id: 'ml.quoteandbind.pup.ml-pup-vehicle-driver-household-details.Edit',
        defaultMessage: 'Edit'
    },
    Remove: {
        id: 'ml.quoteandbind.pup.ml-pup-vehicle-driver-household-details.Remove',
        defaultMessage: 'Remove'
    },
    ExcludedDriver: {
        id: 'ml.quoteandbind.pup.ml-pup-vehicle-driver-household-details.excluded-driver-list.Excluded driver',
        defaultMessage: 'Excluded driver'
    },
    ExcludedDrivers: {
        id: 'ml.quoteandbind.pup.ml-pup-vehicle-driver-household-details.excluded-driver-list.Excluded drivers',
        defaultMessage: 'Excluded drivers'
    },
    RelationshipToInsured: {
        id: 'ml.quoteandbind.pup.ml-pup-vehicle-driver-household-details.excluded-driver-list.RELATIONSHIP TO INSURED',
        defaultMessage: 'RELATIONSHIP TO INSURED'
    },
    ReasonNotListed: {
        id: 'ml.quoteandbind.pup.ml-pup-vehicle-driver-household-details.excluded-driver-list.REASON NOT LISTED',
        defaultMessage: 'REASON NOT LISTED'
    },
    addExcludedDriver: {
        id: 'ml.quoteandbind.pup.ml-pup-vehicle-driver-household-details.ADD EXCLUDED DRIVER',
        defaultMessage: 'ADD EXCLUDED DRIVER'
    },
    HouseholdMember: {
        id: 'ml.quoteandbind.pup.ml-pup-vehicle-driver-household-details.hh-member-list.Household member',
        defaultMessage: 'Household member'
    },
    HouseholdMembers: {
        id: 'ml.quoteandbind.pup.ml-pup-vehicle-driver-household-details.hh-member-list.Household members',
        defaultMessage: 'Household members'
    },
    NonDriver: {
        id: 'ml.quoteandbind.pup.ml-pup-vehicle-driver-household-details.hh-member-list.Non Driver',
        defaultMessage: 'Non Driver'
    },
    NonDrivers: {
        id: 'ml.quoteandbind.pup.ml-pup-vehicle-driver-household-details.hh-member-list.Non Drivers',
        defaultMessage: 'Non Drivers'
    },
    addHHMember: {
        id: 'ml.quoteandbind.pup.ml-pup-vehicle-driver-household-details.ADD HOUSEHOLD MEMBER',
        defaultMessage: 'ADD HOUSEHOLD MEMBER'
    },
    addNonDriver: {
        id: 'ml.quoteandbind.pup.ml-pup-vehicle-driver-household-details.ADD NON DRIVER',
        defaultMessage: 'ADD NON DRIVER'
    },
    ExcludedDriversTooltipHeader: {
        id: 'ml.quoteandbind.pup.ml-pup-vehicle-driver-household-details.How to change from excluded',
        defaultMessage: 'How to change from excluded'
    },
    ExcludedDriverTooltipContent: {
        id: 'ml.quoteandbind.pup.ml-pup-vehicle-driver-household-details.To change to a rated driver, click on Remove and select I need to insure this driver.  To change to an excluded driver, click on Remove and select the applicable reason.',
        defaultMessage: 'To change to a rated driver, click on Remove and select I need to insure this driver.  To change to an excluded driver, click on Remove and select the applicable reason.'
    },
    HouseholdMembersTooltipContent: {
        id: 'ml.quoteandbind.pup.ml-pup-vehicle-driver-household-details.To change to a rated driver, click on Remove and select I need to insure this driver. To change to a household member, click on Remove and select the applicable reason.',
        defaultMessage: 'To change to a rated driver, click on Remove and select I need to insure this driver. To change to a household member, click on Remove and select the applicable reason.'
    },
    HouseholdMemberTooltipHeader: {
        id: 'ml.quoteandbind.pup.ml-pup-vehicle-driver-household-details.How to change from household member',
        defaultMessage: 'How to change from household member'
    },
    ExcludedDriversSubtitle: {
        id: 'ml.quoteandbind.pup.ml-pup-vehicle-driver-household-details.Excluded Drivers Subtitle',
        defaultMessage: 'These are excluded drivers living at your physical address'
    },
    underlyingPolicyNotListed: {
        id: 'ml.quoteandbind.pup.ml-pup-vehicle-driver-household-details.Policy is not listed',
        defaultMessage: 'Policy is not listed'
    },
    objectNeedAttention: {
        id: 'ml.quoteandbind.pup.ml-pup-vehicle-driver-household-details.objectNeedAttention',
        defaultMessage: '<strong>{item} marked with (!) need your attention.</strong> Please click the edit link and fill out all required fields.'
    },
    objectHasBeenAdded: {
        id: 'ml.quoteandbind.pup.ml-pup-vehicle-driver-household-details.objectHasBeenAdded',
        defaultMessage: '<strong>{item}</strong> has been added.'
    },
    objectHasBeenRemoved: {
        id: 'ml.quoteandbind.pup.ml-pup-vehicle-driver-household-details.objectHasBeenRemoved',
        defaultMessage: '<strong>{item}</strong> has been removed. <a>Undo</a>'
    },
    spouseError: {
        id: 'ml.quoteandbind.pup.ml-pup-vehicle-driver-household-details.Spouse was already selected as a relationship to insured on another driver.',
        defaultMessage: 'Spouse was already selected as a relationship to insured on another driver.'
    },
    primaryInsuredError: {
        id: 'ml.quoteandbind.pup.ml-pup-vehicle-driver-household-details.The reason selected is not a valid reason to exclude the named insured. We require this person to be listed.',
        defaultMessage: 'The reason selected is not a valid reason to exclude the named insured. We require this person to be listed.'
    },
    secondaryNamedInsuredError: {
        id: 'ml.quoteandbind.pup.ml-pup-vehicle-driver-household-details.The reason selected is not a valid reason to exclude the secondary named insured. We require this person to be listed.',
        defaultMessage: 'The reason selected is not a valid reason to exclude the secondary named insured. We require this person to be listed.'
    },
    hhMemberHasBeenAdded: {
        id: 'ml.quoteandbind.pup.ml-pup-vehicle-driver-household-details.hhMemberHasBeenAdded',
        defaultMessage: '<strong>{item}</strong> has been added as a household member.'
    },
    nonDriverHasBeenAdded: {
        id: 'ml.quoteandbind.pup.ml-pup-vehicle-driver-household-details.nonDriverHasBeenAdded',
        defaultMessage: '<strong>{item}</strong> has been added as a non driver.'
    },
    nonDriverHasBeenAddedWithUndo: {
        id: 'ml.quoteandbind.pup.ml-pup-vehicle-driver-household-details.nonDriverHasBeenAddedWithUndo',
        defaultMessage: '<strong>{item}</strong> has been added as a non driver.  <a>Undo</a>'
    },
    excludedHasBeenAdded: {
        id: 'ml.quoteandbind.pup.ml-pup-vehicle-driver-household-details.excludedHasBeenAdded.',
        defaultMessage: '<strong>{item}</strong> has been excluded and will not be covered.'
    },
    addNewDriver: {
        id: 'ml.quoteandbind.pup.ml-pup-vehicle-driver-household-details.Add a new driver',
        defaultMessage: 'Add a new driver'
    },
    editDriver: {
        id: 'ml.quoteandbind.pup.ml-pup-vehicle-driver-household-details.Edit driver',
        defaultMessage: 'Edit driver'
    },
    maritalStatusTooltip: {
        id: 'ml.quoteandbind.pup.ml-pup-vehicle-driver-household-details.maritalStatusTooltip',
        defaultMessage: 'A civil union is defined as a state level legally recognized same-sex marriage.  A domestic partner is a relationship between two individuals (same-or opposite-sex) who live together but are not married. Separated (living apart) is living in a separate household from a spouse but spouses are still legally married.'
    },
    reasonForRemove: {
        id: 'ml.quoteandbind.pup.ml-pup-vehicle-driver-household-details.Reason for removing?',
        defaultMessage: '<strong>Reason for removing {item}?</strong>'
    },
    notValidReasonToRemoveDriver: {
        id: 'ml.quoteandbind.pup.ml-pup-vehicle-driver-household-details.The reason selected is not a valid reason to remove this driver. We require this person to be listed as a driver.',
        defaultMessage: 'The reason selected is not a valid reason to remove this driver. We require this person to be listed as a driver.'
    },
    spouseCannotBeRemovedIfLicensed: {
        id: 'ml.quoteandbind.pup.ml-pup-vehicle-driver-household-details.Spouse cannot be removed as a driver if licensed.',
        defaultMessage: 'Spouse cannot be removed as a driver if licensed.'
    },
    notValidReasonToRemoveNamedInsured: {
        id: 'ml.quoteandbind.pup.ml-pup-vehicle-driver-household-details.The reason selected is not a valid reason to remove the named insured. We require this person to be listed.',
        defaultMessage: 'The reason selected is not a valid reason to remove the named insured. We require this person to be listed.'
    },
    notValidReasonToRemoveSecondaryNamedInsured: {
        id: 'ml.quoteandbind.pup.ml-pup-vehicle-driver-household-details.The reason selected is not a valid reason to remove the secondary named insured. We require this person to be listed.',
        defaultMessage: 'The reason selected is not a valid reason to remove the secondary named insured. We require this person to be listed.'
    },
    notValidReasonToRemoveHouseholdMember: {
        id: 'ml.quoteandbind.pup.ml-pup-vehicle-driver-household-details.The reason selected is not a valid reason to remove this household member.',
        defaultMessage: 'The reason selected is not a valid reason to remove this household member.'
    },
    notValidReasonToRemoveExcludedMember: {
        id: 'ml.quoteandbind.pup.ml-pup-vehicle-driver-household-details.The reason selected is not a valid reason to remove this Excluded member.',
        defaultMessage: 'The reason selected is not a valid reason to remove the exclusion.'
    },
    notValidReasonToRemoveNonDriver: {
        id: 'ml.quoteandbind.pup.ml-pup-vehicle-driver-household-details.The reason selected is not a valid reason to remove this Non driver.',
        defaultMessage: 'The reason selected is not a valid reason to remove this non driver.'
    },
    notValidReasonToRemoveHouseholdMemberRequiredListed: {
        id: 'ml.quoteandbind.pup.ml-pup-vehicle-driver-household-details.The reason selected is not a valid reason to remove this household member.  We require this person to be listed as a driver.',
        defaultMessage: 'The reason selected is not a valid reason to remove this household member.  We require this person to be listed as a driver.'
    },
    driverMustBeRatedOrExcluded: {
        id: 'ml.quoteandbind.pup.ml-pup-vehicle-driver-household-details.The driver must be either rated or excluded on this policy.',
        defaultMessage: 'The driver must be either rated or excluded on this policy.'
    },
    driverMustBeRatedOrExcludedText: {
        id: 'ml.quoteandbind.pup.ml-pup-vehicle-driver-household-details.driverMustBeRatedOrExcludedText',
        defaultMessage: 'The reason selected is not a valid reason to remove a driver. If selecting exclusion, a form will be required to be signed and there will be no coverage for that driver on this policy.'
    },
    householdMemberRemoved: {
        id: 'ml.quoteandbind.pup.ml-pup-vehicle-driver-household-details.Household member x has been removed',
        defaultMessage: 'Household member <strong>{item}</strong> has been removed. <a>Undo</a>'
    },
    nonDriverRemoved: {
        id: 'ml.quoteandbind.pup.ml-pup-vehicle-driver-household-details.Non Driver x has been removed',
        defaultMessage: 'Non Driver <strong>{item}</strong> has been removed. <a>Undo</a>'
    },
    cantremovenonDriver: {
        id: 'ml.quoteandbind.pup.ml-pup-vehicle-driver-household-details.Non Driver x can not be removed',
        defaultMessage: 'Non Driver <strong>{item}</strong> can not be removed'
    },
    excludedMemberRemoved: {
        id: 'ml.quoteandbind.pup.ml-pup-vehicle-driver-household-details.Excluded driver x has been removed',
        defaultMessage: 'Excluded driver <strong>{item}</strong> has been removed. <a>Undo</a>'
    },
    householdMemberRemovedNoUndo: {
        id: 'ml.quoteandbind.pup.ml-pup-vehicle-driver-household-details.householdMemberRemovedNoUndo',
        defaultMessage: 'Household member <strong>{item}</strong> has been removed.'
    },
    excludedMemberRemovedNoUndo: {
        id: 'ml.quoteandbind.pup.ml-pup-vehicle-driver-household-details.excludedMemberRemovedNoUndo',
        defaultMessage: 'Excluded driver <strong>{item}</strong> has been removed.'
    },
    hhMemberHasBeenAddedWithUndo: {
        id: 'ml.quoteandbind.pup.ml-pup-vehicle-driver-household-details.hhMemberHasBeenAddedWithUndo',
        defaultMessage: '<strong>{item}</strong> has been added as a household member. <a>Undo</a>'
    },
    HouseholdMemberSubtitleEmptyList: {
        id: 'ml.quoteandbind.pup.ml-pup-vehicle-driver-household-details.Tell us about any additional household members who are not listed',
        defaultMessage: 'Tell us about any additional household members who are not listed'
    },
    NonDriversSubtitleEmptyList: {
        id: 'ml.quoteandbind.pup.ml-pup-vehicle-driver-household-details.Tell us about any additional non drivers who are not listed',
        defaultMessage: 'Tell us about any additional non drivers who are not listed'
    },
    HouseholdMemberSubtitle: {
        id: 'ml.quoteandbind.pup.ml-pup-vehicle-driver-household-details.The following people live in your household but do not drive or have other insurance',
        defaultMessage: 'The following people live in your household but do not drive or have other insurance'
    },
    nonOwnerMemberSubtitle: {
        id: 'ml.quoteandbind.pup.ml-pup-vehicle-driver-household-details.The following people are non drivers that do not drive or have other insurance',
        defaultMessage: 'The following people are non drivers that do not drive or have other insurance'
    },
    addExcludedDriverButtonHelp: {
        id: 'ml.quoteandbind.pup.ml-pup-vehicle-driver-household-details.The driver will be excluded from liability coverage under this policy',
        defaultMessage: 'The driver will be excluded from liability coverage under this policy'
    },
    editExcludedDriver: {
        id: 'ml.quoteandbind.pup.ml-pup-vehicle-driver-household-details.Edit excluded driver',
        defaultMessage: 'Edit excluded driver'
    },
    editHHMember: {
        id: 'ml.quoteandbind.pup.ml-pup-vehicle-driver-household-details.Edit household member',
        defaultMessage: 'Edit household member'
    },
    editNonDriver: {
        id: 'ml.quoteandbind.pup.ml-pup-vehicle-driver-household-details.Edit Non driver',
        defaultMessage: 'Edit Non driver'
    },
    maritalStatusTooltipTitleGPA: {
        id: 'ml.quoteandbind.pup.ml-pup-vehicle-driver-household-details.What is civil union vs domestic partner?',
        defaultMessage: 'What is civil union vs domestic partner?'
    },
    maritalStatusTooltipTextGPA: {
        id: 'ml.quoteandbind.pup.ml-pup-vehicle-driver-household-details.A civil union is defined as a state level legally recognized same-sex marriage. A domestic partner is a relationship between two individuals (same -or opposite-sex) who live together but are not married.',
        defaultMessage: 'A civil union is defined as a state level legally recognized same-sex marriage. A domestic partner is a relationship between two individuals (same -or opposite-sex) who live together but are not married.'
    },
    removeDriver: {
        id: 'ml.quoteandbind.pup.ml-pup-vehicle-driver-household-details.Remove Driver',
        defaultMessage: 'Remove Driver'
    },
    removeHHMember: {
        id: 'ml.quoteandbind.pup.ml-pup-vehicle-driver-household-details.Remove Household Member',
        defaultMessage: 'Remove Household Member'
    },
    removeNonDriver: {
        id: 'ml.quoteandbind.pup.ml-pup-vehicle-driver-household-details.Remove Non Driver',
        defaultMessage: 'Remove Non  Driver'
    },
    removeExcludedDriver: {
        id: 'ml.quoteandbind.pup.ml-pup-vehicle-driver-household-details.Remove Excluded Driver',
        defaultMessage: 'Remove Excluded Driver'
    },
    cilinders: {
        id: 'ml.quoteandbind.pup.ml-pup-vehicle-driver-household-details.Cylinders',
        defaultMessage: 'Cylinders'
    },
    reasonNotListedAsDriver: {
        id: 'ml.quoteandbind.pup.ml-pup-vehicle-driver-household-details.Reason Not Listed as Driver',
        defaultMessage: 'Reason Not Listed as Driver'
    },
    dobTooltip: {
        id: 'ml.quoteandbind.pup.ml-pup-vehicle-driver-household-details.Date of Birth Tooltip Content',
        defaultMessage: 'We need this information to provide you an accurate quote.'
    },
    somethingWentWrong: {
        id: 'ml.quoteandbind.pup.ml-pup-vehicle-driver-household-details.somethingWentWrong',
        defaultMessage: 'Something went wrong during this process. Please try again.'
    },
    accountHolderMinAge: {
        id: 'ml.quoteandbind.pup.accountHolderMinAge',
        defaultMessage: 'We are unable to continue with your quote because this product is not available for applicants younger than 18 years old.'
    }


    
});